import React from "react";

const Urad = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Urad</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
        <table className="table table-striped table-bordered">
          <thead className="text-center">
            <tr>
              <th>Seed Rate</th>
              <th>Sowing Time</th>
              <th>Irrigation</th>
              <th>Maturity Time</th>
              <th>Characterstics</th>
              <th>Average Yield</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="6">
                <strong>T - 9</strong>
              </td>
            </tr>
            <tr>
              <td>6-8 kgs per acre.</td>
              <td>March to April and June to July.</td>
              <td>
                In drought conditions, one or two irrigations are sufficient at
                the time of flowering.
              </td>
              <td>80-85 days.</td>
              <td>
                This is an early maturing variety. Matures all at once. Good
                crop maturity and bold seeds.
              </td>
              <td>4-5 quintals per acre.</td>
            </tr>
            <tr>
              <td colspan="6">
                <strong>PDU - 1</strong>
              </td>
            </tr>
            <tr>
              <td>6-8 kgs per acre.</td>
              <td>March to April and June to July.</td>
              <td>
                In drought conditions, one or two irrigations are sufficient at
                the time of flowering.
              </td>
              <td>70-80 days.</td>
              <td>Plant growth is straight and seeds are bold.</td>
              <td>5-6 quintals per acre.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Urad;
